<template>
    <Form>
        <template v-if="creating">
            <h2>New workspace</h2>
            <div class="font-weight-medium">Name</div>
            <v-form v-model="valid" @submit.prevent="post" ref="form">
                <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
                    {{error}}
                </v-alert>
                <v-text-field outlined dense v-model="form.Name" :rules="[$validators.isSlug]" hint="your company or team name"/>
                <v-btn block type="submit" :disabled="!valid" :loading="loading" class="blue-btn mt-5">Create</v-btn>

                <v-btn block text v-if="workspaces.length" @click="creating = false" class="mt-3">
                    <v-icon small>mdi-arrow-left</v-icon>
                    Back to the list
                </v-btn>
            </v-form>
        </template>

        <template v-else>
            <h2>
                Workspaces for <span class="font-weight-bold">{{account.Email}}</span>
                <v-progress-circular v-if="loading" indeterminate color="green" class="ml-2" />
            </h2>
            <v-btn block elevation="0" large v-for="w in workspaces" :key="w.id" :to="{name: 'workspace', params: {workspaceId: w.id}}" @mouseenter="hovered = w.id" @mouseleave="hovered = ''" class="my-3 py-6">
                {{w.name}}
                <v-spacer />
                <span v-if="hovered === w.id" class="text-lowercase">open</span>
                <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn block @click="creating = true" :disabled="loading" class="blue-btn mt-5">Create another workspace</v-btn>
        </template>

        <div class="pa-12">
            <p class="text-center">
                Not seeing your workspace?
                <router-link :to="{name: 'signin'}">Try a different email.</router-link>
            </p>
        </div>
    </Form>
</template>

<script>
import Form from "@/pages/Form";
export default {
    components: {Form},
    props: {
        redirect: Boolean,
    },

    data() {
        return {
            account: {},
            workspaces: [],
            hovered: '',
            creating: false,
            form: {
                Name: '',
            },
            valid: false,
            error: '',
            loading: false,
        };
    },

    created() {
        this.getAccount();
        this.get();
    },

    methods: {
        getAccount() {
            this.$api.account((data) => {
                this.account = data;
            });
        },
        get() {
            this.loading = true;
            this.$api.workspaceList((data) => {
                this.loading = false;
                const wss = data || [];
                if (!wss.length) {
                    this.creating = true;
                    return;
                }
                if (this.redirect) {
                    const lastId = this.$api.getLastWorkspace();
                    if (lastId) {
                        const w = wss.find((w) => w.id === lastId);
                        if (w) {
                            this.$router.replace({name: 'workspace', params: {workspaceId: w.id}});
                            return;
                        }
                    }
                    if (wss.length === 1) {
                        this.$router.replace({name: 'workspace', params: {workspaceId: wss[0].id}});
                        return;
                    }
                }
                this.workspaces = wss;
            });
        },
        post() {
            this.loading = true;
            this.$api.workspaceCreate(this.form, (data, meta) => {
                this.loading = false;
                if (!meta.error) {
                    this.form.Name = '';
                    this.creating = false;
                    this.$router.push({name: 'workspace_settings', params: {workspaceId: data}});
                } else {
                    this.error = meta.error;
                }
            });
        },
    },
};
</script>

<style scoped>

</style>
